import { Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { CdkPortal, Portal } from "@angular/cdk/portal";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDialogModel } from "./modal-dialog.model";
import { ModalDialogService } from "./modal-dialog.service";

@Component({
    selector: "pcg-ng-modal-dialog",
    template: require('./modal-dialog.component.html')
})
export class ModalDialogComponent implements OnInit, OnDestroy {
    @ViewChild("layout", { read: CdkPortal, static: false })
    public layout: CdkPortal;
    public content: Portal<any>;

    private _overlayRef: OverlayRef;
    private _dialogSubscription: Subscription;

    public constructor(
        private _overlay: Overlay,
        private _dialogService: ModalDialogService
    ) {
    }

    public ngOnInit(): void {
        this._dialogSubscription = this._dialogService.content.subscribe(this.show.bind(this));
    }

    public ngOnDestroy(): void {
        if (this._dialogSubscription) {
            this._dialogSubscription.unsubscribe();
            this._dialogSubscription = null;
        }

        this._overlayRef.dispose();
    }

    private createOverlayRef(config: OverlayConfig): OverlayRef {
        const overlayRef = this._overlay.create(config);
        overlayRef.backdropClick().subscribe(this.hide.bind(this));
        return overlayRef;
    }

    private show(dialog: ModalDialogModel): void {
        this.cleanUp();

        if (dialog) {
            this._overlayRef = this.createOverlayRef(dialog.config);
            this.content = dialog.portal;
            this._overlayRef.attach(this.layout);
        }
    }

    private hide(): void {
        this._dialogService.hide();
    }

    private cleanUp(): void {
        if (this._overlayRef && this._overlayRef.hasAttached()) {
            this._overlayRef.detach();
            this._overlayRef.dispose();
        }
    }
}
